import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AdminLayout } from '@/layouts/AdminLayout';
import { LoginPage } from '@/pages/LoginPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { DashboardPage } from '@/pages/DashboardPage';
import { PropFirmsPage } from '@/pages/PropFirmsPage';
import { PropFirmEditorPage } from '@/pages/PropFirmEditorPage';
import { UnlistedFirmsPage } from '@/pages/UnlistedFirmsPage';
import { ExclusiveOffersPage } from '@/pages/ExclusiveOffersPage';
import { MediaLibraryPage } from '@/pages/MediaLibraryPage';
import { BlogPage } from '@/pages/BlogPage';
import { BlogEditorPage } from '@/pages/BlogEditorPage';
import { NewsPage } from '@/pages/NewsPage';
import { ReviewsPage } from '@/pages/ReviewsPage';
import { UsersPage } from '@/pages/UsersPage';
import { VerifiedPayoutsPage } from '@/pages/VerifiedPayoutsPage';
import { LoyaltyProgramPage } from '@/pages/LoyaltyProgramPage';
import { LeaderboardPage } from '@/pages/LeaderboardPage';
import { AnnouncementsPage } from '@/pages/AnnouncementsPage';
import { AdminAccountsPage } from '@/pages/AdminAccountsPage';
import { SiteSettingsPage } from '@/pages/SiteSettingsPage';
import { RedirectsPage } from '@/pages/RedirectsPage';
import '@/App.css';

// Placeholder for Admin Accounts page
const PlaceholderPage = ({ title }) => (
  <div className="flex h-full items-center justify-center">
    <div className="text-center">
      <h2 className="text-2xl font-bold text-slate-900 mb-2">{title}</h2>
      <p className="text-slate-600">This page is under construction</p>
    </div>
  </div>
);

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard" element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="firms" element={<PropFirmsPage />} />
            <Route path="firms/new" element={<PropFirmEditorPage />} />
            <Route path="firms/:id/edit" element={<PropFirmEditorPage />} />
            <Route path="firms/unlisted" element={<UnlistedFirmsPage />} />
            <Route path="offers" element={<ExclusiveOffersPage />} />
            <Route path="media" element={<MediaLibraryPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/new" element={<BlogEditorPage />} />
            <Route path="blog/:id/edit" element={<BlogEditorPage />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="reviews" element={<ReviewsPage />} />
            <Route path="payouts" element={<VerifiedPayoutsPage />} />
            <Route path="loyalty" element={<LoyaltyProgramPage />} />
            <Route path="leaderboard" element={<LeaderboardPage />} />
            <Route path="admins" element={<AdminAccountsPage />} />
            <Route path="announcements" element={<AnnouncementsPage />} />
            <Route path="settings" element={<SiteSettingsPage />} />
            <Route path="redirects" element={<RedirectsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
